<template>
  <BaseLayout>
    <template v-slot:top_buttons>
      <div class="d-flex justify-content-end mb-2">
        <DocLink docKey="settings" text="Помощь по разделу" />
      </div>
    </template>
    <div class="row mb-12 g-6">
      <div class="col-xl-4 col-lg-5 order-1 order-md-0">
        <LoadingBlock :loading="loadingUserInfo">
          <div class="card">
            <div class="card-body pt-12">
              <h5 class="pb-4 border-bottom mb-4">{{ user_info.name }}</h5>
              <ul class="list-unstyled mb-6">
                <li class="mb-2">
                  <span class="h6">Эл. почта: </span>
                  <span>{{ user_info.email }}</span>
                </li>
              </ul>
            </div>
          </div>
        </LoadingBlock>
        
        <!-- Информация о подписке: из биллинга или из старого сервиса подписок -->
        <BillingTariffCard v-if="billingEnabled" class="mt-6"/>
        <LoadingBlock v-else :loading="loadingSubscription">
          <div class="card mt-6">
            <div class="card-body pt-12">
              <h5 class="pb-4 border-bottom mb-4">Подписка</h5>
              <template v-if="subscriptionInfo.has_active_subscription && subscriptionInfo.subscription">
                <ul class="list-unstyled mb-6">
                  <li class="mb-2">
                    <span class="h6">Тариф: </span>
                    <span class="badge bg-primary">{{ subscriptionInfo.subscription.name || 'Не указан' }}</span>
                  </li>
                  <li class="mb-2">
                    <span class="h6">Цена: </span>
                    <span class="fw-bold">{{ subscriptionInfo.subscription.price }} ₽</span>
                  </li>
                  <li class="mb-2" v-if="!isFreeTariff">
                    <span class="h6">Статус: </span>
                    <span :class="getSubscriptionStatusClass(subscriptionInfo.subscription.is_paid)">
                      {{ subscriptionInfo.subscription.is_paid ? 'Оплачена' : 'Не оплачена' }}
                    </span>
                  </li>
                  <li class="mb-2" v-if="!isFreeTariff && subscriptionInfo.subscription.end_date">
                    <span class="h6">Дата окончания: </span>
                    <span>{{ formatDate(subscriptionInfo.subscription.end_date) }}</span>
                  </li>
                </ul>


                <!-- Лимиты тарифа -->
                <div v-if="subscriptionInfo.subscription && subscriptionInfo.subscription.limits && subscriptionInfo.subscription.limits.length > 0">
                  <h6 class="mb-3">Лимиты тарифа:</h6>
                  <div class="row g-2">
                    <div class="col-12" v-for="limit in subscriptionInfo.subscription.limits" :key="limit.limit_type">
                      <div class="border rounded p-3">
                        <div class="d-flex justify-content-between align-items-center">
                          <span class="fw-medium">{{ getLimitTypeName(limit.limit_type) }}</span>
                          <span class="badge bg-light text-dark">{{ formatNumber(limit.quantity) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Дополнительные лимиты -->
                <div v-if="subscriptionInfo.extra_limits && subscriptionInfo.extra_limits.product && subscriptionInfo.extra_limits.product.length > 0" class="mt-4">
                  <h6 class="mb-3">Дополнительные лимиты:</h6>
                  <div class="mb-3" v-for="extra in subscriptionInfo.extra_limits.product" :key="extra.id">
                    <div class="card border-light">
                      <div class="card-body p-3">
                        <div class="d-flex justify-content-between align-items-center">
                          <div>
                            <div class="fw-medium">{{ extra.name }}</div>
                            <small class="text-muted">{{ formatDate(extra.start_date) }} - {{ formatDate(extra.end_date) }}</small>
                          </div>
                          <div class="text-end">
                            <div class="fw-bold text-primary">+{{ formatNumber(extra.limit_quantity) }}</div>
                            <span :class="extra.is_paid ? 'badge bg-success' : 'badge bg-danger'">
                              {{ extra.is_paid ? 'Оплачено' : 'Не оплачено' }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Итоговые лимиты -->
                <div v-if="subscriptionInfo.extra_limits && subscriptionInfo.extra_limits.product && subscriptionInfo.extra_limits.product.length > 0 && subscriptionInfo.total_limits" class="mt-4">
                  <h6 class="mb-3">Итоговые лимиты:</h6>
                  <div class="border border-success border-opacity-25 rounded p-4 bg-white">
                    <div class="row g-3 text-center">
                      <div class="col-6" v-if="subscriptionInfo.total_limits.store">
                        <div class="h4 text-success mb-1">{{ formatNumber(subscriptionInfo.total_limits.store) }}</div>
                        <div class="text-muted small">Магазинов</div>
                      </div>
                      <div class="col-6" v-if="subscriptionInfo.total_limits.product">
                        <div class="h4 text-success mb-1">{{ formatNumber(subscriptionInfo.total_limits.product) }}</div>
                        <div class="text-muted small">Товаров</div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="text-center py-4">
                  <i class="ti ti-credit-card-off text-muted mb-3" style="font-size: 3rem;"></i>
                  <p class="text-muted">Активная подписка не найдена</p>
                  <p class="text-muted small mb-4">Обратитесь в поддержку для активации тарифа</p>
                  <router-link :to="renewLink" class="btn btn-primary waves-effect">
                    <i class="ti ti-credit-card me-2"></i>
                    Продлить тариф
                  </router-link>
                </div>
              </template>

              <div class="demo-inline-spacing mb-4">
                  <router-link v-if="!isFreeTariff" :to="renewLink" class="btn btn-primary waves-effect">
                    <i class="ti ti-credit-card me-2"></i>
                    Продлить тариф
                  </router-link>
                  <router-link to="/tariffs" class="btn btn-outline-primary waves-effect">
                    <i class="ti ti-refresh me-2"></i>
                    Сменить тариф
                  </router-link>
                </div>
            </div>
          </div>
        </LoadingBlock>
      </div>
      <div class="col-xl-8 col-lg-7 order-0 order-md-1">
        <LoadingBlock :loading="loadingCompanyInfo">
          <div class="card">
            <div class="card-body pt-12">
              <h5 class="pb-4 border-bottom mb-4">Информация о компании</h5>
              <ul class="list-unstyled mb-6">
                <li class="mb-2" v-if="company_info.display_id">
                  <span class="h6">Номер компании: </span>
                  <span>{{ company_info.display_id }}</span>
                </li>
                <li class="mb-2">
                  <span class="h6">Название: </span>
                  <span>{{ company_info.name }}</span>
                </li>
                <li class="mb-2">
                  <span class="h6">База для расчета налогов: </span>
                  <span>{{ getTaxName(company_info.tax_type) }}</span>
                </li>
                <li class="mb-2">
                  <span class="h6">Процент налога: </span>
                  <span>{{ company_info.tax_percent }}</span>
                </li>
                <li class="mb-2">
                  <span class="h6">Часовой пояс: </span>
                  <span>{{ company_info.timezone }}</span>
                </li>
              </ul>
              <div class="demo-inline-spacing">
                <button class="btn btn-outline-primary waves-effect" @click="editCompany()">
                  Редактировать
                </button>
              </div>
            </div>
          </div>
        </LoadingBlock>
      </div>
    </div>
    <BaseModal ref="companyModal" modal-title="Настройки компании">
      <CompanyForm :item="company_info" @company-success="companySuccess"/>
    </BaseModal>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/layouts/Base.vue";
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import {subscription} from "@/data/subscription";

import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {getUser} from "@/api/user";
import BaseModal from "@/components/Modal.vue";
import CompanyForm from "@/components/forms/Company.vue";
import {taxTypes} from "@/data/company";
import DocLink from "@/components/tools/DocLink.vue";
import {billingEnabled} from "@/modules/billing";
import BillingTariffCard from "@/modules/billing/components/TariffCard.vue";

export default {
  name: 'SettingsView',
  components: {CompanyForm, BaseModal, LoadingBlock, BaseLayout, DocLink, BillingTariffCard},
  data() {
    return {
      company_info: {},
      user_info: {},
      loadingUserInfo: true,
      loadingCompanyInfo: true,
      loadingSubscription: true
    }
  },
  computed: {
    subscriptionInfo() {
      return subscription.subscription_info
    },
    isFreeTariff() {
      if (!this.subscriptionInfo.has_active_subscription || !this.subscriptionInfo.subscription) {
        return false
      }
      const price = this.subscriptionInfo.subscription.price
      return price === 0 || price === null || price === undefined
    },
    billingEnabled() {
      return billingEnabled
    },
    // Ссылки старого блока подписки (без биллинга)
    renewLink() {
      return '/payment'
    }
  },
  directives: {},
  methods: {
    async setUserData() {
      this.loadingUserInfo = true
      const result = await getUser(user.user_id)
      this.user_info = result.data
      this.loadingUserInfo = false
    },
    async setCompanyData() {
      this.loadingCompanyInfo = true
      await user.getActiveCompany()
      this.company_info = {...await user.loadCompanyInfo()}
      this.loadingCompanyInfo = false
    },
    editCompany() {
      this.$refs.companyModal.openModal()
    },
    companySuccess(item) {
      this.company_info = {...item}
      this.$refs.companyModal.closeModal()
    },
    getTaxName(code) {
      const tax = taxTypes.find((item) => item.code === code)
      if (typeof tax !== 'undefined') {
        return tax.name
      }
    },
    getSubscriptionStatusClass(isPaid) {
      return isPaid ? 'badge bg-success' : 'badge bg-danger';
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('ru-RU', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    formatNumber(number) {
      if (number === null || number === undefined) return '0';
      return number.toLocaleString('ru-RU');
    },
    getLimitTypeName(limitType) {
      const limitTypes = {
        'product': 'Товары',
        'store': 'Магазины',
        'strategy': 'Стратегии',
        'user': 'Пользователи',
        'tracked_offers': 'Цены на витрине'
      };
      return limitTypes[limitType] || limitType;
    },
    async setSubscriptionData() {
      this.loadingSubscription = true;
      try {
        await subscription.getSubscriptionInfo();
      } catch (error) {
        console.error('Ошибка загрузки подписки:', error);
      }
      this.loadingSubscription = false;
    },
    async setPage() {
      PageInfo.title = 'Настройки'
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: PageInfo.title
        }
      ]
      await user.getUserBase()
      await this.setUserData()
      await this.setCompanyData()
      // С биллингом подписку показывает BillingTariffCard
      if (!billingEnabled) {
        await this.setSubscriptionData()
      }
    }
  },
  async mounted() {
    await this.setPage()
  }
}
</script>